import comp from "./Step2.js";
export default comp;
